import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconsModule } from '@app/components/icons/icons.module';
import { HeaderModule } from '@app/components/header/header.module';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { SharedModule } from '@app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { CreditCodeComponent } from './credit-code.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreditCodeRoutingModule } from './credit-code-routing.module';


@NgModule({
  declarations: [CreditCodeComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ContainerScrollModule,
    HeaderModule,
    IconsModule,
    CreditCodeRoutingModule
  ]
})
export class CreditCodeModule { }
